import { Component, OnInit } from '@angular/core';
import { AuthentificationService } from '../../services/authentification.service';
import { ModalsService } from '../../services/modals.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(
    private auth: AuthentificationService,
    private modals: ModalsService,
  ) { }

  ngOnInit() {
    // this.modals.openLoadingScreen();
  }

  authorize() {
    this.auth.startAuthorization();
  }

}





// WEBPACK FOOTER //
// ./src/app/main/login/login.component.ts